export default {"src":"/_next/static/media/infrastructure.e06a76c4.svg","height":764,"width":901,"blurWidth":0,"blurHeight":0};